import React from "react";

function Cell({
	children,
	className = "",
	cols = 1,
	lgCols = 1,
	xlCols = 1,
	rows = 1,
	lgRows = 1,
	xlRows = 1,
	...props
}) {
	// Costruisce dinamicamente le classi Tailwind CSS per colonne e righe
	const gridClasses = `
		col-span-${cols} 
		lg:col-span-${lgCols} 
		xl:col-span-${xlCols} 
		row-span-${rows} 
		lg:row-span-${lgRows} 
		xl:row-span-${xlRows}
	`;

	return (
		<div
			className={`bg-white shadow-xl !rounded-lg overflow-hidden p-4 ${gridClasses} ${className}`}
			{...props}
		>
			{children}
		</div>
	);
}

export default Cell;
